var moment = require('moment');
var module = angular.module('octopusApp.infrastructure');

module.directive('dateRangePicker', function () {
  return {
    restrict: 'E',
    replace: true,
    template: '<div class="date-range-picker-display"><a href="" class="picker">{{ start | moment:"D MMMM YYYY" }}<span> to </span>{{ end | moment:"D MMMM YYYY" }}<span class="pull-right"><i class="fa fa-calendar"></i></span></a></div>',
    scope: {
      start: '=',
      end: '=',
      change: '&'
    },
    link: function ($scope, $element, $attributes) {
      $(".picker", $element).click(function () {
        var options = {};
        options.opens = "left";
        options.startDate = $scope.start;
        options.endDate = $scope.end;
        options.ranges = {
          'Today': [moment(), moment()],
          'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
          'Last 7 days': [moment().subtract(7, 'days'), moment()],
          'Last 30 days': [moment().subtract(30, 'days'), moment()],
          'Last 90 days': [moment().subtract(90, 'days'), moment()]
        };

        $element.daterangepicker(options, function(start, end) {
          $scope.$apply(function () {
            start = start.startOf('day');
            end = end.add(1, 'day').startOf('day').subtract(1, 'seconds');
            $scope.start = start;
            $scope.end = end;
          });
          $scope.$apply(function() {
            $scope.change();
          });
        });
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/directives/date_range_picker.js
// module id = 656
// module chunks = 1